"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const member_1 = __importDefault(require("./member"));
const styled_components_1 = __importDefault(require("styled-components"));
const MemberList = ({ members, onMemberClick, activeMemberId }) => {
    return ((0, jsx_runtime_1.jsx)(ListWrapper, { children: (0, jsx_runtime_1.jsx)("div", { children: members.map((member) => ((0, jsx_runtime_1.jsx)(member_1.default, { member: member, selected: member.id === activeMemberId, onClick: onMemberClick }, member.name))) }, void 0) }, void 0));
};
exports.MemberList = MemberList;
const ListWrapper = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: max-content;
  padding: 0 1rem;
  margin-bottom: 1rem;
  overflow-y: auto;

  & > div {
    & > div > span:first-of-type {
      margin-top: 0;
    }

    & > div:first-of-type {
      margin-top: 0;
    }

    & > div:last-of-type {
      padding-bottom: ${({ theme }) => theme.spacings.m};
      margin-bottom: 0;
    }

    & > div:not(:last-of-type) {
      margin-bottom: 1rem;
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding-bottom: 0;
  }
`;
//# sourceMappingURL=MemberList.js.map